<template>
    <div>
        <b-modal
            centered
            no-close-on-backdrop
            hide-header-close
            hide-footer
            v-model="modalPOP.resumeDraft"
        >
        <template #modal-header>
         <div class="mx-auto">
            <img src="../../assets/icon/warning.svg" alt="">
         </div>
        </template>
            <div class="mt--4">
                <div class="d-flex flex-column justify-content-center align-items-center">
                    <h3>
                        ต้องการทำรายการต่อในภายหลัง ?
                    </h3>
                    <h4 class="text-center">
                        หากคุณออกจากหน้านี้ โดยไม่ทำการบันทึกฉบับร่าง <br>รายการที่คุณกำลังดำเนินการนี้จะหายไป
                    </h4>
                </div>
                <div class="row mt-3 align-items-center">
                    <div class="col-sm-12 col-lg-5 d-flex justify-content-center">
                        <button type="button" class="btn btn-light" @click="removeDraft()">ละทิ้งรายการ</button>
                    </div>
                    <div class="col-sm-12 col-lg-7 mobile-scale-margin d-flex justify-content-center">
                        <button type="button" class="btn btn-primary" @click="saveDraft()">                            
                            บันทึกฉบับร่าง            
                        </button>
                        <button type="button" class="btn btn-primary" @click="closeModal('resumeDraft')">                            
                            ทำรายการต่อ                            
                        </button>
                    </div>

                </div>
            </div>
        </b-modal>
    </div>
</template>

<script>
export default {
    props: {
        modalPOP: Object
    },
    methods: {
        closeModal(key) {
            return this.$emit('resumeDraft', key)
        },
        saveDraft() {
            return this.$emit('saveDraft')
        },
        removeDraft() {
            return this.$emit('removeDraft')
        }
    }
    
}
</script>

<style>

</style>